export default "__VITE_ASSET__Dkco_ofm__"